import { get, post, put } from '@api/request';

export async function fetchConferences(
  { microsoftService },
  authenticationToken,
  { inProgress },
) {
  const url = `${microsoftService}/import/conferences?inProgress=${inProgress}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchConferenceByID(
  { microsoftService },
  authenticationToken,
  { conferenceID },
) {
  const url = `${microsoftService}/import/conference/${conferenceID}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function createConference(
  { microsoftService },
  authenticationToken,
  { payload },
) {
  const url = `${microsoftService}/import/conferences`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function fetchConferenceAttendance(
  { microsoftService },
  authenticationToken,
  { conferenceID },
) {
  const url = `${microsoftService}/import/conference/${conferenceID}/attendance`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchConferenceRecording(
  { microsoftService },
  authenticationToken,
  { conferenceID },
) {
  const url = `${microsoftService}/import/conference/${conferenceID}/recording`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function startConference(
  { microsoftService },
  authenticationToken,
  { conferenceID },
) {
  const url = `${microsoftService}/import/conference/${conferenceID}/start`;
  const { body } = await put(authenticationToken, url);
  return body;
}
